import Vue from "vue";

import axios from "@/http/axios";

const state = {
  benchmarks: {},
};

const getters = {
  getBenchmark: (state) => (benchmarkId) => {
    return state.benchmarks[benchmarkId];
  },
  getAllBenchmarks: (state) => {
    return state.benchmarks;
  },
};

const mutations = {
  FETCH_BENCHMARK_SUCCESS: (state, { benchmarkId, data }) => {
    if (!data) return;
    Vue.set(state.benchmarks, benchmarkId, data);
  },
  FETCH_ALL_BENCHMARKS_SUCCESS: (state, { data }) => {
    if (!data) return;
    data.forEach((element) => {
      Vue.set(state.benchmarks, element["id_"], element);
    });
  },
};

const actions = {
  async fetchBenchmark({ commit, state }, { benchmarkId }) {
    if (state.benchmarks && state.benchmarks[benchmarkId]) {
      // Don't update the state (by putting data to null) if we already have this
      // benchmark.
      commit("FETCH_BENCHMARK_SUCCESS", { benchmarkId, data: null });
      return;
    }
    const response = await axios.get("/api/benchmarks/" + benchmarkId);
    commit("FETCH_BENCHMARK_SUCCESS", { benchmarkId, data: response.data });
  },
  async fetchAllBenchmarks({ commit }) {
    const response = await axios.get("/api/benchmarks/");
    commit("FETCH_ALL_BENCHMARKS_SUCCESS", { data: response.data });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
